import React from "react";
import Mesh from "../assets/images/FooterMesh.svg";
import whiteYellow from "../assets/images/whiteYellologo.svg";
import CopyRight from "../assets/images/copyright.png";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className="tw-w-full tw-bg-[#062533]">
      <div
        style={{ backgroundImage: `url(${Mesh})` }}
        className="tw-h-full  tw-bg-cover"
      >
        <div className="tw-mx-[5vw] 2xl:tw-mx-[10vw] tw-pt-14 lg:tw-pt-28 tw-pb-4  tw-h-full tw-text-white tw-flex tw-flex-col">
          <div className="tw-flex max-lg:tw-gap-10 lg:tw-justify-between tw-flex-col lg:tw-flex-row max-lg:tw-items-center ">
            <div className="lg:tw-w-1/4">
              <img className="tw-w-64 lg:tw-w-72" src={whiteYellow} alt="" />
              <p className="tw-mt-1 tw-tracking-[0.04em] lg:tw-tracking-wider tw-text-base lg:tw-text-sm">
                Unleash the Power of Finance ERP
              </p>
            </div>
            <div className="tw-w-[90%] lg:tw-w-3/4 tw-flex tw-justify-evenly max-lg:tw-flex-wrap">
              <div className="tw-w-[105px]">
                <h3 className="tw-text-base 2xl:tw-text-xl tw-uppercase tw-underline tw-underline-offset-8">
                  Company
                </h3>
                <ul className="tw-mt-4 tw-text-sm 2xl:tw-text-md tw-space-y-1 tw-flex tw-flex-col">
                  <Link to="/">About Us</Link>
                  <Link to="/">Terms of use</Link>
                  <Link to="/">Privacy Policy</Link>
                </ul>
              </div>
              <div>
                <h3 className="tw-text-base 2xl:tw-text-xl tw-uppercase tw-underline tw-underline-offset-8">
                  ERP Features
                </h3>
                <ul className="tw-mt-4 tw-text-sm 2xl:tw-text-md tw-space-y-1 tw-flex tw-flex-col">
                  <Link to="/">Accounting</Link>
                  <Link to="/">Invoicing</Link>
                  <Link to="/">Sales</Link>
                  <Link to="/">Inventory</Link>
                  <Link to="/">Production</Link>
                  <Link to="/">Purchase</Link>
                  <Link to="/">Payroll</Link>
                  <Link to="/">Project Management</Link>
                  <Link to="/">MultiLinkngual</Link>
                  <Link to="/">Reports</Link>
                </ul>
              </div>
              <div>
                <h3 className="tw-text-base 2xl:tw-text-xl tw-uppercase tw-underline tw-underline-offset-8 tw-flex tw-flex-col">
                  Locations
                </h3>
                <p className="tw-text-sm 2xl:tw-text-md tw-mt-4 tw-max-w-80 tw-w-fit">
                  # 59. S.Y.No 101, 3rd Main NR Layout, FCI Godwon Main Road
                  <br />
                  Dooravani Nagar, Vijinapura
                  <br /> Bangalore 560016
                  <br /> India.
                </p>
              </div>
            </div>
          </div>
          <div className="tw-mx-auto">
            <div className="tw-text-xl tw-flex tw-gap-3 xs:tw-gap-2 tw-my-5 max-xs:tw-flex-col tw-items-center">
              <input
                className="tw-px-4 tw-py-3 tw-w-[16rem] md:tw-w-[27rem] tw-rounded-md tw-text-black tw-outline-none focus:tw-outline-none"
                type="email"
                name="email"
                id=""
              />
              <button className=" tw-text-sm ProductSansBold  tw-w-fit tw-px-5 md:tw-px-16 tw-py-4 tw-rounded-md tw-uppercase tw-bg-[#fdd60e] tw-text-black focus:tw-outline-none">
                Subscribe
              </button>
            </div>
            <div className="tw-flex tw-justify-center tw-items-center tw-gap-1 tw-mt-5">
              <img className="tw-w-5" src={CopyRight} alt="" srcset="" />
              <span className="tw-text-xs">
                Copyright@2024 Jnana Software Technologies Pvt. Ltd.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
